import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Divider} from 'views/components';
import {HoverToolBox, translate} from 'views/module';

import Message from './Message';

import displayResource from 'utils/miscellaneous/display_resource';
import moment from 'moment';

const MessageFeedBox = (props) => {
  const [toolbarVisible, setToolbarVisible] = React.useState(false);
  const [mouseOver, setMouseOver] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const {
    message,
    userRn,
    jobBackend,
  } = props;

  React.useEffect(() => {
    if (editMode) {
      setToolbarVisible(false);
      return;
    }
    setToolbarVisible(mouseOver);
  }, [editMode, mouseOver]);

  const submittedBy = message.submittedBy;
  const author = displayResource(submittedBy);
  const timestampInfoCalculator = () => {
    let timestampPrefixLabel = null;
    switch (message.messageType) {
      case 'ANNOUNCEMENTS':
        timestampPrefixLabel = translate('career.jobDetail.Messages.Timestamp.AnnouncedOn');
        break;
      case 'COMMENTS':
        timestampPrefixLabel = translate('career.jobDetail.Messages.Timestamp.CommentedOn');
        break;
      default:
        timestampPrefixLabel = translate('career.jobDetail.Messages.Timestamp.PostedOn');
        break;
    }

    const formattedTimestamp = moment(message.createdAt).format(translate('timeFormat.VerboseDay'));

    return `${timestampPrefixLabel} ${formattedTimestamp}`;
  };

  const onClickEdit = () => {
    setEditMode(true);
  };

  const onClickEditSave = (event, newMessage, setLoading) => {
    setLoading(true);
    jobBackend.messages.update(message.messageRn, newMessage,
        () => {
          setLoading(false);
          setEditMode(false);
        }, () => {
          setLoading(false);
          setEditMode(false);
        });
  };

  const onClickEditCancel = () => {
    setEditMode(false);
  };

  const onEmojiSelected = (emoji) => {
    const prevEmojiUsers = message?.emoji?.[emoji];
    if (prevEmojiUsers?.find((user) => user === userRn)) {
      jobBackend.messages.removeEmoji(message.messageRn, emoji, userRn);
      return;
    }

    jobBackend.messages.addEmoji(message.messageRn, emoji, userRn);
  };

  const onClickDelete = (setIsDeleting) => {
    setIsDeleting(true);
    jobBackend.messages.delete(
        message.messageRn,
        () => setIsDeleting(false),
        () => setIsDeleting(false),
    );
  };

  return (
    <Box>
      <Divider/>
      <Box
        onMouseOver={(event) => {
          setMouseOver(true);
          setAnchorEl(event.currentTarget);
        }}
        onMouseLeave={() => setMouseOver(false)}
        sx={{
          backgroundColor: toolbarVisible ? 'background.highlighted': 'inherit',
          px: {md: 2, xs: 1},
        }}
      >
        <Message
          userRn={userRn}
          fullName={author}
          message={message.body.blob}
          emojis={message.emoji}
          editMode={editMode}
          onClickSave={onClickEditSave}
          onClickCancel={onClickEditCancel}
          onEmojiSelected={onEmojiSelected}
          emojisWithRequesterData={message.emojisWithRequesterData}
          timestampLabel={timestampInfoCalculator()}
          truncate
        />
        <HoverToolBox
          toolBar={toolbarVisible}
          anchorEl={anchorEl}
          copiedText={message.body.blob}
          onClickEdit={onClickEdit}
          onClickDelete={onClickDelete}
          onEmojiSelected={onEmojiSelected}
          hideTool={{
            edit: userRn !== message.submittedBy?.resourceRn,
            delete: userRn !== message.submittedBy?.resourceRn,
          }}
        />
      </Box>
    </Box>
  );
};

MessageFeedBox.propTypes = {
  message: PropTypes.object.isRequired,
  jobBackend: PropTypes.object.isRequired,
  userRn: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  userRn: state.user.userRn,
});

export default connect(mapStateToProps, dispatch)(React.memo(MessageFeedBox));
